import { create } from '@dojo/framework/core/vdom';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { createNlsMiddleware, lccstate } from 'lcc-state';
import { XAPI } from '@holmescorp/xapi';
const icache = createICacheMiddleware();
const nls = createNlsMiddleware('audio');
const factory = create({
    icache,
    nls,
    lccstate
});
export const audio = factory(({ middleware: { icache, nls, lccstate } }) => {
    const { messages: { filepath = '[audio] filepath' } } = nls();
    const api = {
        setup(playlist) {
            const trackIndex = icache.getOrSet('currentTrack', 0);
            const player = icache.getOrSet('player', document.createElement('audio'));
            const play_list = icache.getOrSet('playlist', playlist);
            const { association, product } = window.hcstatic;
            const audioId = play_list[trackIndex].key;
            const assoc = association?.toLowerCase();
            const actor = lccstate.get(lccstate.path('actor_xapi'));
            const target = new XAPI.Activity({ id: 'https://w3id.org/xapi/audio/activity-type/audio' });
            const context = new XAPI.Context({
                extensions: { 'urn:holmes:audio-id': `${assoc}-${product}-${audioId}` }
            });
            const recordEvent = (verb) => {
                const stmnt = new XAPI.Statement({
                    actor,
                    verb,
                    target,
                    context
                }).asVersion();
                XAPI.svc.set_statement({ stmnt });
            };
            const set_loaded = () => {
                const loaded = icache.get('filesLoaded') || false;
                if (!loaded) {
                    icache.set('filesLoaded', true);
                }
            };
            player.onloadeddata = set_loaded;
            player.onloadedmetadata = set_loaded;
            player.onplay = () => recordEvent(XAPI.Verbs.PLAYED);
            player.onpause = () => recordEvent(XAPI.Verbs.PAUSED);
            player.onseeked = () => recordEvent(XAPI.Verbs.SEEKED);
            player.onended = () => {
                recordEvent(XAPI.Verbs.COMPLETED);
                const current = icache.get('currentTrack') || 0;
                if (current < play_list.length - 1) {
                    this.change_track(current + 1);
                }
            };
            player.onerror = () => {
                icache.getOrSet('loadError', true);
            };
            icache.set('player', player);
        },
        change_track(trackNumber) {
            const currentTrack = icache.get('currentTrack');
            const player = icache.get('player');
            const playlist = icache.get('playlist') || [];
            if (!player || trackNumber < 0 || trackNumber >= playlist.length) {
                return;
            }
            const priorTrackElement = document.getElementById(`track-${currentTrack}`);
            const newTrackElement = document.getElementById(`track-${trackNumber}`);
            player.src = `${filepath}/${playlist[trackNumber].key}.mp3`;
            player.autoplay = true;
            priorTrackElement?.classList.remove('playing');
            newTrackElement?.classList.add('playing');
            icache.set('currentTrack', trackNumber);
            icache.set('player', player);
        },
        get_playlist() {
            return icache.get('playlist') || [];
        },
        setup_audio_player() {
            if (icache.getOrSet('playerLoaded', false) || icache.get('loadError')) {
                return;
            }
            const player = icache.get('player');
            if (!player) {
                return;
            }
            const playlist = icache.get('playlist') || [];
            if (!playlist.length) {
                return;
            }
            const container = document.getElementById('audio-player');
            const track = icache.get('currentTrack') || 0;
            container?.firstChild?.remove();
            player.src = `${filepath}/${playlist[track].key}.mp3`;
            player.controls = true;
            player.setAttribute('controlslist', 'nodownload');
            container?.appendChild(player);
            if (container) {
                const newTrackElement = document.getElementById(`track-${track}`);
                newTrackElement?.classList.add('playing');
                icache.set('currentTrack', track);
                icache.set('playerLoaded', true);
                icache.set('player', player);
            }
        },
        teardown() {
            const player = icache.get('player');
            if (player) {
                player.pause();
                player.removeAttribute('src');
                player.load();
                player.onloadeddata = null;
                player.onloadedmetadata = null;
                player.onplay = null;
                player.onpause = null;
                player.onseeked = null;
                player.onended = null;
                player.onerror = null;
            }
            const current = icache.get('currentTrack');
            const priorTrackElement = document.getElementById(`track-${current}`);
            priorTrackElement?.classList.remove('playing');
            const container = document.getElementById('audio-player');
            container?.firstChild?.remove();
            icache.clear();
        }
    };
    return api;
});
export default audio;
